module.exports = __webpack_public_path__ + "img/Logo Colored-2@2x.cecef125.png";